<template>
  <div class="page-content rules">
    <h1 class="page-title">
      {{ $locale("sideMenu.performance.discountRuleTemplate") }}
      <el-tooltip popper-class="tooltip-content" effect="dark" :content="$locale('discountRuleTemplate.spec')" placement="top">
        <img src="../../assets/img/tips.png" alt="Tips" />
      </el-tooltip>
    </h1>
    <el-row class="search-area">
      <el-col  class="makeInline" :lg="16" :md="16" :sm="24">
        <el-input :placeholder="$locale('form.plsEnterYourName')" v-model="onSearch.name" @keyup.enter.native="searchFn" class="searchMaxWidth">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchFn"></i>
        </el-input>
        <el-button class="egl-btn-yellow makeLeft" @click="searchFn">{{ $locale("global.search") }}</el-button>
      </el-col>
      <el-col  class="ta-r" :lg="8" :md="8" :sm="24">
        <el-button class="egl-btn-yellow" @click="toDetail('create')">{{ $locale('discountRules.createRule') }}</el-button>
      </el-col>
    </el-row>

    <el-table :data="ruleList" class="egl-table" stripe>
      <el-table-column type="index" label="" min-width="20%" ></el-table-column>
      <el-table-column prop="name" type='' :label="$locale('global.name')" ></el-table-column>
      <el-table-column align="center" min-width="20%">
        <template slot="header">{{ $locale("global.control") }}</template>
        <template slot-scope="scope">
          <div class="handle">
            <a @click="toDetail('edit', scope.row.id)">{{ $locale("global.edit") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="deleteRule_fn(scope.row.id, scope.row.name)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <CommPagination
      :total="pageCount"
      :curPage="onSearch.page"
      :pageSize="onSearch.pageSize"
      @current-change="choosePage"
    />
  </div>
</template>
<style scoped>
  .searchMaxWidth{
    max-width: 350px;
    margin-right: 5px;
  }
  .makeLeft {
    margin-left: 5px;
  }
  .makeInline {
    white-space:nowrap;
  }
  .el-col {
    margin-bottom: 5px;
  }
</style>
<script>
import CommPagination from "@/components/common/CommPagination";
import { getDiscountRuleTemplateList, deleteRule } from "@/helpers/service/api/discountRuleTemplate";
import countDownAlert from "@/utils/countDownAlert";

export default {
  name: "discountRules",
  data() {
    return {
      onSearch: {
        name: "",
        // status: "active",
        page: 0,
        pageSize: 10,
      },
      ruleList: [],
      pageCount: 0,

    };
  },
  created() {
    this.searchFn();
  },
  methods: {
    searchFn() {
      getDiscountRuleTemplateList({
        ...this.onSearch,
        cinemaId: window.localStorage.getItem("cinemaId")
      }).then(res => {
        this.pageCount = res.data.count;
        this.onSearch = { ...this.onSearch, page: res.data.page, pageSize: res.data.pageSize };
        this.ruleList = res.data.data;
      });
    },
    toDetail(act = "create", id) {
      if (act === "create") {
        this.$router.push({ path: "/discountRules/create" });
      } else {
        this.$router.push({ path: `/discountRules/edit/${id}` });
      }
    },
    deleteRule_fn(id, name) {
      const that = this;
      const confirmHtml = `<i class="egl-confirm-question">?</i>
        <span class="result-text">${this.$locale("global.delete")} ${name}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false,
      }).then(() => {
        deleteRule({ id }).then(res => {
          if(res.success) {
            countDownAlert({
              content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                that.searchFn();
              }
            });
          }
        });
      });
    },
    choosePage(page) {
      this.onSearch.page = page - 1;
      this.searchFn();
    }
  },
  components: {
    CommPagination,
  },
};
</script>